import { observer } from "mobx-react";
import { IAppliedFilterChipComponent } from "../BaseChipComponents/IAppliedFilterChipComponent";
import AppliedFilterChip from "../BaseChipComponents/AppliedFilterChipBase";
import React from "react";
import { useChipFiltersStore } from "../BaseChipComponents/chipUtils";
import { isOpenEndedCallDuration } from "./callDurationSliderState";

export const CallDurationChip = observer(function (
    props: IAppliedFilterChipComponent,
) {
    const applicationFiltersStore = useChipFiltersStore(props);
    const minCallDuration = applicationFiltersStore.minCallDuration ?? 0;
    // The maximum is exclusive, but a chip states the range the way its bucket is labelled: the
    // bound and the label are the same number. The separator is an en dash for the same reason,
    // matching the bucket labels the backend writes and the Smart Banner's phrasing, so clicking a
    // bar reading "2–5 min" does not produce a chip spelling it differently.
    const maxCallDuration = applicationFiltersStore.maxCallDuration ?? 0;
    const chipLabel =
        minCallDuration === 0 && maxCallDuration === 0
            ? "Call Duration: Any Duration"
            : isOpenEndedCallDuration(minCallDuration, maxCallDuration)
              ? // Reaches as far as the filter goes, which is the last duration bucket's range.
                `Call Duration: ${minCallDuration}+ min`
              : `Call Duration: ${minCallDuration}–${maxCallDuration} min`;

    return (
        <AppliedFilterChip
            disabled={props.disabled}
            isApplicable={props.isApplicable}
            onRemove={() => applicationFiltersStore.setCallDuration([])}
        >
            {chipLabel}
        </AppliedFilterChip>
    );
});
